import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AboutUs = () => {
  return (
    <main id="main-content" className="bg-white">
      <Navbar />
      
      {/* Header Section */}
      <section className="pt-32 pb-24 bg-[#630503] relative overflow-hidden">
        <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-1/5 bg-gradient-to-b from-[#630503] to-white"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="mb-16">
              <span className="inline-block bg-white/10 backdrop-blur-sm text-white px-6 py-3 text-sm font-medium uppercase tracking-[0.2em] mb-8 rounded-full">
                Our Heritage
              </span>
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-light text-white mb-8 leading-[1.1] max-w-4xl mx-auto">
                <span className="font-bold">About Us</span>
              </h1>
              <div className="w-24 h-px bg-white/40 mx-auto mb-8"></div>
              <p className="text-lg lg:text-xl leading-relaxed text-white/95 max-w-3xl mx-auto">
                Discover the rich heritage and symbolic meaning behind P.S. 11x, the home of Bronx Brilliance.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* School Crest Heritage */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Our <span className="font-bold text-[#630503]">Crest</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <div className="max-w-4xl mx-auto">
              <p className="text-lg text-gray-600 leading-relaxed">
                The crest of P.S. 11x honors our rich Highbridge heritage. The hawk that flies above pays homage to the Indigenous tribes of The Bronx. Ivy was selected to represent growth and resilience. Ivy has the ability to grow, even in harsh conditions and symbolized perseverance and the capacity to overcome challenges, just like the people of the Highbridge community.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Scales of Justice */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Scales of <span className="font-bold text-[#630503]">Justice</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <div className="max-w-4xl mx-auto">
              <p className="text-lg text-gray-600 leading-relaxed">
                The scales of justice recognized the need for equity in the two-building models of P.S. 11x to ensure that resources are shared equitably among both schools. The scales of justice also honor the community activists of the Highbridge community who have long fought for more schools and additional funding.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Bronx Brilliance */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Bronx <span className="font-bold text-[#630503]">Brilliance</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <div className="max-w-4xl mx-auto">
              <p className="text-lg text-gray-600 leading-relaxed">
                Built in 1889, P.S. 11x school community is the home of Bronx Brilliance and looks to empower all Bronx residents to tap into their gifts and talents- to make the world a better place.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Indigenous History Link */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Learn <span className="font-bold text-[#630503]">More</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-12">
              Discover the rich Indigenous history of The Bronx and deepen your understanding of our community's heritage.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="https://bronxriver.org/post/greenway/the-indigenous-history-of-the-bronx-river-a-story-of-honor"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#630503] text-white hover:bg-[#4a0402] font-semibold px-8 py-4 text-base transition-colors rounded-lg"
              >
                Learn About Indigenous History of The Bronx
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-[#630503]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl lg:text-4xl font-light text-white mb-8">
              Join Our <span className="font-bold">Community</span>
            </h2>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed mb-12">
              Be part of the P.S. 11x legacy where heritage meets innovation, and every student is empowered to achieve Bronx Brilliance.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/our-school" className="bg-white text-[#630503] hover:bg-white/90 font-semibold px-8 py-4 text-base transition-colors rounded-lg inline-block">
                Explore Our School
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default AboutUs; 